var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"close-side-bar-button",on:{"mouseup":this.clickCloseButton}},[_c('svg',{staticClass:"close-side-bar-icon"},[_c('path',{attrs:{"d":"m10 10 l20 20 m-20 0 l20 -20 z"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }